function traceRequestInterceptor(config) {
    var _a = config || {}, traceIdGenerator = _a.traceIdGenerator, logConfig = _a.logConfig;
    var logger = (logConfig || {}).logger;
    if (traceIdGenerator) {
        try {
            var headers = config.headers || {};
            headers['Trace-Id'] = traceIdGenerator();
            config.headers = headers;
        }
        catch (e) {
            if (logger && logger.collect) {
                logger.collect('CUSTOM', 'ESHOP_REQUEST_TRACEID_ERROR', {
                    message: (e && e.message) || '生成traceId错误',
                });
            }
        }
    }
    return config;
}
export default traceRequestInterceptor;
//# sourceMappingURL=index.js.map